import "isomorphic-fetch";
import "babel-polyfill";
import auth from "../Login/authService";
import Sentry from "../Globals/sentry";

export const httpPost = (url, payload) => {
  var token = auth.getToken();
  return fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(payload)
  }).then(response => {
    if (response.status === 401) {
      userNotLoggedIn();
    } else if (response.status >= 400) {
      const profile = auth.getProfile();
      Sentry.withScope(scope => {
        scope.setExtras({
          host: window.location.hostname,
          profile: profile,
          err: response
        });
        Sentry.captureException(JSON.stringify(response));
      });
      throw new Error(JSON.stringify({status: response.status, statusText: response.statusText}));
    }
    return response;
  });
};

export const httpGet = url => {
  var token = auth.getToken();
  return fetch(url, {
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token
    }
  }).then(response => {
    if (response.status === 401) {
      userNotLoggedIn();
    } else if (response.status >= 400) {
      const profile = auth.getProfile();
      Sentry.withScope(scope => {
        scope.setExtras({
          host: window.location.hostname,
          profile: profile,
          err: response
        });
        Sentry.captureException(JSON.stringify(response));
      });
      throw new Error(response.statusText);
    }
    return response;
  });
};

export const httpPut = (url, payload) => {
  var token = auth.getToken();
  return fetch(url, {
    method: "put",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(payload)
  }).then(response => {
    if (response.status === 401) {
      userNotLoggedIn();
    } else if (response.status >= 400) {
      const profile = auth.getProfile();
      Sentry.withScope(scope => {
        scope.setExtras({
          host: window.location.hostname,
          profile: profile,
          err: response
        });
        Sentry.captureException(JSON.stringify(response));
      });
      throw new Error(JSON.stringify({status: response.status, statusText: response.statusText}));
    }

    return response;
  });
};

export const httpDelete = (url, payload) => {
  var token = auth.getToken();
  return fetch(url, {
    method: "delete",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(payload)
  }).then(response => {
    if (response.status === 401) {
      userNotLoggedIn();
    } else if (response.status >= 400) {
      const profile = auth.getProfile();
      Sentry.withScope(scope => {
        scope.setExtras({
          host: window.location.hostname,
          profile: profile,
          err: response
        });
        Sentry.captureException(JSON.stringify(response));
      });
      throw new Error(response.statusText);
    }
    return response;
  });
};

function userNotLoggedIn() {
  auth.logout();
  window.location = auth.hostname + "/login";
}

export const httpGetNoAuth = url => {
  return fetch(url, {
    headers: {
      Accept: "application/json"
    }
  }).then(response => {
    if (response.status >= 400) {
      const profile = auth.getProfile();
      Sentry.withScope(scope => {
        scope.setExtras({
          host: window.location.hostname,
          profile: profile,
          err: response
        });
        Sentry.captureException(JSON.stringify(response));
      });
      throw new Error(response.statusText);
    }
    return response;
  });
};



// WEBPACK FOOTER //
// ./src/App/Util/http.js